<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 sm12 lg9>
          <v-card>
            <v-card-title>
              <h3 class="display-1">Sessionen</h3>
            </v-card-title>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="sessions"
                :pagination.sync="pagination"
              >
                <template slot="items" slot-scope="props">
                  <td class="session-title">
                    <router-link :to="props.item.url">{{ props.item.title }}</router-link>
                  </td>
                  <td class="session-opening-date">
                    {{ props.item.date | toLocaleDateString }}
                  </td>
                  <td class="session-published" v-if="$isSuperuser()">
                    <PublishedChip :value="props.item" />
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-btn
        v-if="$isSuperuser()"
        :to="{ name: 'new-session' }"
        color="green"
        dark
        fixed
        bottom
        right
        fab
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-container>
  </BaseLayout>
</template>

<script>
import Session from '@/models/session';

export default {
  name: 'IndexSession',
  async initialAsyncData() {
    await Session.fetchAll();
  },
  data() {
    return {
      sessions: Session.all(),
      pagination: {
        descending: true,
        sortBy: 'date',
        rowsPerPage: 25,
      },
      headers: [
        { text: 'Titel', value: 'title' },
        { text: 'Datum', value: 'date' },
        ...(this.$isSuperuser() ? [{ text: 'Publikation', value: 'is_published' }] : []),
      ],
    };
  },
};
</script>
